<template>
  <div class="component-block">
    <div class="spin" v-if="loading">
      <LoadingSpinner/>
    </div>
    <NavigationView/>
    <div class="block-container">
      <div class="tableview-block">
        <div class="tableview-top">
          <div class="tableview-top-left">
            <div class="tableview-top-count">
              Все перевозчики {{ startLoading ? '' : `(${tableItems.length})` }}
            </div>
            <div class="tableview-top-search pc">
              <label>
                <svg class="tableview-top-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                      fill="#4D5460"/>
                </svg>
                <input v-model="searchValue" type="text" placeholder="Найти перевозчика...">
                <button
                    @click="this.searchValue = ''"
                    v-if="searchValue !== ''"
                    class="tableview-top-search-close">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"/>
                  </svg>
                </button>
              </label>
            </div>
          </div>
          <div>
<!--            <button-->
<!--                v-if="$store.state.user.roles.includes('ROLE_CARRIERS')"-->
<!--                @click="showCreateDialog"-->
<!--                class="button-add-transparent pc"-->
<!--            >-->
<!--              Добавить перевозчика-->
<!--            </button>-->
            <button @click="clearFilters" class="clear-filters pc">
              Сбросить фильтры
            </button>
<!--            <button @click="showCreateDialog" class="button-add-transparent mobile">-->
<!--              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M24 11H13V0H11V11H0V13H11V24H13V13H24V11Z"/>-->
<!--              </svg>-->
<!--            </button>-->
            <button @click="clearFilters" class="clear-filters mobile">
              <svg x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512"
                   xml:space="preserve" class="">
                <g>
                  <path
                      d="M19 13a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 19 13zm2.75 0A4.756 4.756 0 0 1 17 17.75a4.689 4.689 0 0 1-2.25-.593V21a.75.75 0 0 1-1.2.6l-4-3a.75.75 0 0 1-.3-.6v-4a.745.745 0 0 0-.221-.53L3.91 8.35a2.231 2.231 0 0 1-.66-1.59V4.5A2.253 2.253 0 0 1 5.5 2.25h13a2.253 2.253 0 0 1 2.25 2.25v2.26a2.235 2.235 0 0 1-.66 1.591l-.615.614A4.738 4.738 0 0 1 21.75 13zm-8.5 6.5v-3.619a4.7 4.7 0 0 1-1-2.881A4.756 4.756 0 0 1 17 8.25a4.692 4.692 0 0 1 .969.1l1.06-1.061a.745.745 0 0 0 .221-.53V4.5a.751.751 0 0 0-.75-.75h-13a.751.751 0 0 0-.75.75v2.26a.745.745 0 0 0 .221.53l5.119 5.12a2.231 2.231 0 0 1 .66 1.59v3.625zm7-6.5A3.25 3.25 0 1 0 17 16.25 3.254 3.254 0 0 0 20.25 13z"
                      opacity="1" data-original="#000000" class="">
                  </path>
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div class="tableview-top-search mobile">
          <label>
            <svg class="tableview-top-search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M17.9996 16.94L13.3031 12.2435C14.5231 10.7515 15.1229 8.84761 14.9785 6.92571C14.8341 5.00381 13.9565 3.21094 12.5273 1.91793C11.0981 0.624921 9.22654 -0.0692924 7.29982 -0.0211186C5.37311 0.0270553 3.53862 0.813931 2.1758 2.17675C0.812985 3.53957 0.0261092 5.37406 -0.0220646 7.30077C-0.0702385 9.22748 0.623975 11.099 1.91698 12.5282C3.20999 13.9574 5.00287 14.835 6.92476 14.9794C8.84666 15.1238 10.7505 14.524 12.2426 13.304L16.9391 18.0005L17.9996 16.94ZM7.49959 13.5005C6.3129 13.5005 5.15287 13.1486 4.16617 12.4894C3.17948 11.8301 2.41044 10.893 1.95632 9.79664C1.50219 8.70028 1.38337 7.49388 1.61488 6.33C1.84639 5.16611 2.41784 4.09701 3.25695 3.2579C4.09607 2.41878 5.16516 1.84734 6.32905 1.61583C7.49294 1.38432 8.69934 1.50314 9.79569 1.95726C10.8921 2.41139 11.8291 3.18042 12.4884 4.16712C13.1477 5.15381 13.4996 6.31385 13.4996 7.50054C13.4978 9.09129 12.8651 10.6164 11.7403 11.7412C10.6154 12.866 9.09034 13.4988 7.49959 13.5005Z"
                  fill="#4D5460"/>
            </svg>
            <input v-model="searchValue" type="text" placeholder="Найти перевозчика...">
            <button
                @click="this.searchValue = ''"
                v-if="searchValue !== ''"
                class="tableview-top-search-close">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"/>
              </svg>
            </button>
          </label>
        </div>
        <div
            v-if="!startLoading"
            class="tableview-main"
        >
          <div
              class="tableview-main-left"
              :class="{ 'not-selected': itemsSelected.length === 0 }"
          >
            <!-- v-model:items-selected="itemsSelected"-->
            <EasyDataTable
                buttons-pagination
                :headers="tableHeaders"
                :items="tableItems"
                :search-value="searchValue"
                rows-of-page-separator-message="из"
                theme-color="#005291"
                table-class-name="customize-table"
                class="carriers-table"
                @click-row="selectCarrier"
            >
              <template #item-status="item">
                <div class="status-point-container">
                  <div class="status-point"
                       :class="{ 'inactive': item.status === 'ia' }"
                  ></div>
                </div>
                <div class="selected-field"
                     :class="{ 'selected': item.id === selectedCarrier.id }"
                ></div>
              </template>
              <template #empty-message>
                Данные не найдены
              </template>
            </EasyDataTable>
            <div class="tableview-main-selected" v-if="itemsSelected.length > 0">
              <div class="tableview-main-selected-left">
                Выбрано: {{ itemsSelected.length }}
              </div>
              <div class="tableview-main-selected-actions">
                <div class="tableview-main-selected-actions-text">
                  Действия с выбранными:
                </div>
<!--                <button class="download-btn">-->
<!--                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <g clip-path="url(#clip0_1_1594)">-->
<!--                      <path-->
<!--                          d="M16.1218 17.4451C16.1948 17.5268 16.2509 17.6221 16.287 17.7255C16.3231 17.8289 16.3385 17.9385 16.3322 18.0478C16.326 18.1572 16.2982 18.2642 16.2505 18.3629C16.2028 18.4615 16.1362 18.5497 16.0543 18.6226L14.7327 19.8009C14.5062 20.0251 14.2377 20.2023 13.9425 20.3223C13.6473 20.4422 13.3313 20.5027 13.0127 20.5001C12.6822 20.5007 12.3549 20.4361 12.0494 20.31C11.744 20.1839 11.4664 19.9987 11.2327 19.7651L9.94601 18.6201C9.86426 18.5473 9.79764 18.4591 9.74997 18.3606C9.70229 18.2621 9.67449 18.1552 9.66814 18.0459C9.65533 17.8252 9.7307 17.6085 9.87767 17.4434C10.0246 17.2783 10.2312 17.1784 10.4519 17.1655C10.5611 17.1592 10.6706 17.1744 10.7739 17.2104C10.8773 17.2463 10.9726 17.3023 11.0543 17.3751L12.1668 18.3701V12.1667C12.1668 11.9457 12.2546 11.7338 12.4109 11.5775C12.5672 11.4212 12.7792 11.3334 13.0002 11.3334C13.2212 11.3334 13.4331 11.4212 13.5894 11.5775C13.7457 11.7338 13.8335 11.9457 13.8335 12.1667V18.3709L14.946 17.3776C15.1109 17.2307 15.3274 17.1554 15.5479 17.168C15.7684 17.1807 15.9748 17.2803 16.1218 17.4451V17.4451ZM15.7968 6.63424C15.6538 6.5898 15.5239 6.5106 15.4189 6.40372C15.3139 6.29683 15.237 6.16559 15.1952 6.02174C14.7539 4.60514 13.8527 3.37623 12.6343 2.52958C11.4158 1.68293 9.94978 1.26694 8.46825 1.34748C6.98672 1.42802 5.57439 2.00048 4.4549 2.97422C3.33542 3.94796 2.57275 5.26733 2.28767 6.7234C1.99516 8.19591 2.23122 9.72441 2.95434 11.0401C2.11138 11.4753 1.42593 12.1636 0.99427 13.0084C0.562611 13.8532 0.406433 14.812 0.547673 15.7501C0.764882 16.8399 1.34835 17.8227 2.20119 18.5351C3.05402 19.2476 4.12491 19.6469 5.23601 19.6667H7.16684C7.38785 19.6667 7.59981 19.5789 7.75609 19.4227C7.91237 19.2664 8.00017 19.0544 8.00017 18.8334C8.00017 18.6124 7.91237 18.4004 7.75609 18.2441C7.59981 18.0879 7.38785 18.0001 7.16684 18.0001H5.23601C4.5243 17.9864 3.83784 17.734 3.28683 17.2833C2.73582 16.8327 2.35224 16.2099 2.19767 15.5151C2.10718 14.918 2.20592 14.3077 2.48003 13.7696C2.75413 13.2316 3.18985 12.7929 3.72601 12.5151C4.10817 12.3039 4.39178 11.9507 4.51546 11.5319C4.63913 11.1131 4.59293 10.6625 4.38684 10.2776C4.06326 9.66045 3.87225 8.9825 3.82605 8.28722C3.77986 7.59195 3.87949 6.89469 4.11858 6.24018C4.35766 5.58567 4.73091 4.98836 5.21438 4.48656C5.69785 3.98476 6.28086 3.58956 6.92603 3.3263C7.57119 3.06305 8.26426 2.93755 8.96078 2.95785C9.65729 2.97816 10.3419 3.14383 10.9706 3.44423C11.5993 3.74463 12.1583 4.17314 12.6117 4.70225C13.0652 5.23136 13.403 5.84941 13.6035 6.51674C13.7268 6.91899 13.9466 7.28504 14.2436 7.58305C14.5405 7.88107 14.9058 8.10203 15.3077 8.22674C16.3963 8.55798 17.3384 9.25231 17.9771 10.194C18.6158 11.1357 18.9125 12.2678 18.8177 13.4017C18.7549 14.2834 18.4328 15.1269 17.8918 15.8259C17.7571 16.0012 17.6976 16.2228 17.7262 16.442C17.7549 16.6611 17.8695 16.8599 18.0448 16.9947C18.22 17.1294 18.4416 17.1889 18.6608 17.1603C18.88 17.1316 19.0788 17.017 19.2135 16.8417C19.9477 15.8845 20.3878 14.7345 20.4802 13.5317C20.606 12.0198 20.2098 10.5104 19.3576 9.25526C18.5053 8.0001 17.2486 7.07501 15.7968 6.63424V6.63424Z"-->
<!--                          fill="#374957"/>-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0_1_1594">-->
<!--                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->
<!--                  <span class="pc">Скачать в Excel</span>-->
<!--                  <span class="mobile">Excel</span>-->
<!--                </button>-->
                <button
                    v-if="$store.state.user.roles.includes('ROLE_CARRIERS')"
                    @click="deleteMultiple"
                    class="delete-selected-btn"
                >
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1_1597)">
                      <path
                          d="M18.8337 3.83333H14.667V2.16667C14.667 1.72464 14.4914 1.30072 14.1788 0.988155C13.8663 0.675595 13.4424 0.5 13.0003 0.5H8.00033C7.5583 0.5 7.13437 0.675595 6.82181 0.988155C6.50925 1.30072 6.33366 1.72464 6.33366 2.16667V3.83333H2.16699V5.5H3.83366V18C3.83366 18.663 4.09705 19.2989 4.56589 19.7678C5.03473 20.2366 5.67062 20.5 6.33366 20.5H14.667C15.33 20.5 15.9659 20.2366 16.4348 19.7678C16.9036 19.2989 17.167 18.663 17.167 18V5.5H18.8337V3.83333ZM8.00033 2.16667H13.0003V3.83333H8.00033V2.16667ZM15.5003 18C15.5003 18.221 15.4125 18.433 15.2562 18.5893C15.1 18.7455 14.888 18.8333 14.667 18.8333H6.33366C6.11265 18.8333 5.90068 18.7455 5.7444 18.5893C5.58812 18.433 5.50033 18.221 5.50033 18V5.5H15.5003V18Z"
                          fill="#FF7C7C"/>
                      <path d="M9.66666 8.83282H8V15.4995H9.66666V8.83282Z" fill="#FF7C7C"/>
                      <path d="M13.0007 8.83282H11.334V15.4995H13.0007V8.83282Z" fill="#FF7C7C"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1_1597">
                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <span>Удалить</span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="selectedCarrier !== -1" class="tableview-main-right">
            <div class="tableview-main-right-top">
              <div class="tableview-main-right-name">
                {{ selectedCarrier.name }}
              </div>
              <div class="tableview-main-right-status"
                   :class="{ 'inactive': selectedCarrier.status === 'ia' }"
              />
            </div>
            <!--            <div class="edit-dropdown">-->
            <!--              <div class="edit-dropdown-label">Статус</div>-->
            <!--              <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="true"-->
            <!--                      aria-expanded="false">-->
            <!--                {{ editableCarrier.status == 'ia' ? 'Неактивный перевозчик' : 'Активный перевозчик' }}-->
            <!--              </button>-->
            <!--              <ul class="dropdown-menu">-->
            <!--                <li><a class="dropdown-item" href="#" @click="editableCarrier.status = 'a'">Активный перевозчик</a>-->
            <!--                </li>-->
            <!--                <li><a class="dropdown-item" href="#" @click="editableCarrier.status = 'ia'">Неактивный-->
            <!--                  перевозчик</a></li>-->
            <!--              </ul>-->
            <!--            </div>-->
            <div
                class="singleselect-label-wrapper"
                :class="{ 'pointers-inactive': !$store.state.user.roles.includes('ROLE_CARRIERS') }"
            >
              <div class="edit-multiselect-label">Статус</div>
              <Multiselect
                  v-model="editableCarrier.status"
                  noResultsText="Результаты не найдены"
                  :canDeselect="false"
                  :options="[
                      {'value':'a', 'label': 'Активный перевозчик'},
                      {'value':'ia', 'label': 'Неактивный перевозчик'},
                  ]"
              />
            </div>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.nameError }"
            >
              <div class="edit-input-label">Наименование</div>
              <input
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.name"
                  type="text"
                  placeholder="Введите наименование">
              <div class="edit-error" v-if="editValidationErrors.nameError">{{ editValidationErrors.nameError }}</div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.innError }"
            >
              <div class="edit-input-label">ИНН организации</div>
              <input
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.inn"
                  type="text"
                  placeholder="Введите ИНН организации">
              <div class="edit-error" v-if="editValidationErrors.innError">{{ editValidationErrors.innError }}</div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.kppError }"
            >
              <div class="edit-input-label">КПП организации</div>
              <input
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.kpp"
                  type="text"
                  placeholder="Введите КПП организации">
              <div class="edit-error" v-if="editValidationErrors.kppError">{{ editValidationErrors.kppError }}</div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.orgnError }"
            >
              <div class="edit-input-label">ОГРН организации</div>
              <input
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.orgn"
                  type="text"
                  placeholder="Введите ОГРН организации">
              <div class="edit-error" v-if="editValidationErrors.orgnError">{{ editValidationErrors.orgnError }}</div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.contactNameError }"
            >
              <div class="edit-input-label">ФИО контактного лица</div>
              <input
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.contact_name"
                  type="text"
                  placeholder="Введите ФИО контактного лица">
              <div class="edit-error" v-if="editValidationErrors.contactNameError">{{
                  editValidationErrors.contactNameError
                }}
              </div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.contactEmailError }"
            >
              <div class="edit-input-label">E-mail контактного лица</div>
              <input
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.contact_email"
                  type="text"
                  placeholder="Введите E-mail контактного лица">
              <div class="edit-error" v-if="editValidationErrors.contactEmailError">{{
                  editValidationErrors.contactEmailError
                }}
              </div>
            </label>
            <label
                class="edit-input"
                :class="{ 'error-input': editValidationErrors.contactPhoneError }"
            >
              <div class="edit-input-label">Телефон контактного лица</div>
              <input
                  v-maska="'+7 (###) ###-##-##'"
                  :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
                  v-model="editableCarrier.contact_phone"
                  type="text"
                  placeholder="Введите Телефон контактного лица">
              <div class="edit-error" v-if="editValidationErrors.contactPhoneError">{{
                  editValidationErrors.contactPhoneError
                }}
              </div>
            </label>
            <div
                class="multiselect-label-wrapper"
                :class="{ 'pointers-inactive': !$store.state.user.roles.includes('ROLE_CARRIERS') }"
            >
              <div class="edit-multiselect-label">Пользователи с доступом</div>
              <Multiselect
                  v-model="editableCarrier.access_users"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="true"
                  noResultsText="Результаты не найдены"
                  :options="multiselectItems"
              />
            </div>
            <button
                v-if="$store.state.user.roles.includes('ROLE_CARRIERS')"
                @click="updateCarrier"
                class="button-update"
            >
              Сохранить изменения
            </button>
          </div>
        </div>
        <LoadingSpinner v-else/>
      </div>
    </div>

    <!--    create carrier modal-->
    <ModalView
        v-model:show="createDialogVisible"
        :title="'Добавить перевозчика'"
    >
      <div class="singleselect-label-wrapper">
        <div class="edit-multiselect-label">Статус</div>
        <Multiselect
            v-model="creatableCarrier.status"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="[
                      {'value':'a', 'label': 'Активный перевозчик'},
                      {'value':'ia', 'label': 'Неактивный перевозчик'},
                  ]"
        />
      </div>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.nameError }"
      >
        <div class="edit-input-label">Наименование</div>
        <input v-model="creatableCarrier.name" type="text" placeholder="Введите наименование">
        <div class="edit-error" v-if="createValidationErrors.nameError">{{ createValidationErrors.nameError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.innError }"
      >
        <div class="edit-input-label">ИНН организации</div>
        <input v-model="creatableCarrier.inn" type="text" placeholder="Введите ИНН организации">
        <div class="edit-error" v-if="createValidationErrors.innError">{{ createValidationErrors.innError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.kppError }"
      >
        <div class="edit-input-label">КПП организации</div>
        <input v-model="creatableCarrier.kpp" type="text" placeholder="Введите КПП организации">
        <div class="edit-error" v-if="createValidationErrors.kppError">{{ createValidationErrors.kppError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.orgnError }"
      >
        <div class="edit-input-label">ОГРН организации</div>
        <input v-model="creatableCarrier.orgn" type="text" placeholder="Введите ОГРН организации">
        <div class="edit-error" v-if="createValidationErrors.orgnError">{{ createValidationErrors.orgnError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.contactNameError }"
      >
        <div class="edit-input-label">ФИО контактного лица</div>
        <input v-model="creatableCarrier.contact_name" type="text" placeholder="Введите ФИО контактного лица">
        <div class="edit-error" v-if="createValidationErrors.contactNameError">
          {{ createValidationErrors.contactNameError }}
        </div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.contactEmailError }"
      >
        <div class="edit-input-label">E-mail контактного лица</div>
        <input v-model="creatableCarrier.contact_email" type="text" placeholder="Введите E-mail контактного лица">
        <div class="edit-error" v-if="createValidationErrors.contactEmailError">
          {{ createValidationErrors.contactEmailError }}
        </div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': createValidationErrors.contactPhoneError }"
      >
        <div class="edit-input-label">Телефон контактного лица</div>
        <input
            v-maska="'+7 (###) ###-##-##'"
            v-model="creatableCarrier.contact_phone"
            type="text"
            placeholder="Введите Телефон контактного лица">
        <div class="edit-error" v-if="createValidationErrors.contactPhoneError">
          {{ createValidationErrors.contactPhoneError }}
        </div>
      </label>
      <div class="multiselect-label-wrapper">
        <div class="edit-multiselect-label">Пользователи с доступом</div>
        <Multiselect
            v-model="creatableCarrier.access_users"
            mode="tags"
            :close-on-select="false"
            :searchable="true"
            noResultsText="Результаты не найдены"
            :options="multiselectItems"
        />
      </div>

      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button @click="createCarrier" type="button" class="button-add">Добавить перевозчика</button>
      </template>
    </ModalView>

    <!--    edit carrier modal-->
    <ModalView
        class="edit-modal"
        v-model:show="editDialogVisible"
        v-model:selectedObj="selectedCarrier"
        :title="'Перевозчик: ' + selectedCarrier.name"
    >
      <div
          class="singleselect-label-wrapper"
          :class="{ 'pointers-inactive': !$store.state.user.roles.includes('ROLE_CARRIERS') }"
      >
        <div class="edit-multiselect-label">Статус</div>
        <Multiselect
            v-model="editableCarrier.status"
            noResultsText="Результаты не найдены"
            :canDeselect="false"
            :options="[
                      {'value':'a', 'label': 'Активный перевозчик'},
                      {'value':'ia', 'label': 'Неактивный перевозчик'},
                  ]"
        />
      </div>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.nameError }"
      >
        <div class="edit-input-label">Наименование</div>
        <input
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.name"
            type="text"
            placeholder="Введите наименование">
        <div class="edit-error" v-if="editValidationErrors.nameError">{{ editValidationErrors.nameError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.innError }"
      >
        <div class="edit-input-label">ИНН организации</div>
        <input
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.inn"
            type="text"
            placeholder="Введите ИНН организации">
        <div class="edit-error" v-if="editValidationErrors.innError">{{ editValidationErrors.innError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.kppError }"
      >
        <div class="edit-input-label">КПП организации</div>
        <input
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.kpp"
            type="text"
            placeholder="Введите КПП организации">
        <div class="edit-error" v-if="editValidationErrors.kppError">{{ editValidationErrors.kppError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.orgnError }"
      >
        <div class="edit-input-label">ОГРН организации</div>
        <input
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.orgn"
            type="text"
            placeholder="Введите ОГРН организации">
        <div class="edit-error" v-if="editValidationErrors.orgnError">{{ editValidationErrors.orgnError }}</div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.contactNameError }"
      >
        <div class="edit-input-label">ФИО контактного лица</div>
        <input
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.contact_name"
            type="text"
            placeholder="Введите ФИО контактного лица">
        <div class="edit-error" v-if="editValidationErrors.contactNameError">{{
            editValidationErrors.contactNameError
          }}
        </div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.contactEmailError }"
      >
        <div class="edit-input-label">E-mail контактного лица</div>
        <input
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.contact_email"
            type="text"
            placeholder="Введите E-mail контактного лица">
        <div class="edit-error" v-if="editValidationErrors.contactEmailError">{{
            editValidationErrors.contactEmailError
          }}
        </div>
      </label>
      <label
          class="edit-input"
          :class="{ 'error-input': editValidationErrors.contactPhoneError }"
      >
        <div class="edit-input-label">Телефон контактного лица</div>
        <input
            v-maska="'+7 (###) ###-##-##'"
            :readonly="!$store.state.user.roles.includes('ROLE_CARRIERS')"
            v-model="editableCarrier.contact_phone"
            type="text"
            placeholder="Введите Телефон контактного лица">
        <div class="edit-error" v-if="editValidationErrors.contactPhoneError">{{
            editValidationErrors.contactPhoneError
          }}
        </div>
      </label>
      <div
          class="multiselect-label-wrapper"
          :class="{ 'pointers-inactive': !$store.state.user.roles.includes('ROLE_CARRIERS') }"
      >
        <div class="edit-multiselect-label">Пользователи с доступом</div>
        <Multiselect
            v-model="editableCarrier.access_users"
            mode="tags"
            :close-on-select="false"
            :searchable="true"
            noResultsText="Результаты не найдены"
            :options="multiselectItems"
        />
      </div>
      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button
            v-if="$store.state.user.roles.includes('ROLE_CARRIERS')"
            @click="updateCarrier"
            type="button"
            class="button-add">
          Сохранить изменения
        </button>
      </template>
    </ModalView>
  </div>
</template>

<script>

import NavigationView from "@/components/NavigationView";
import store from "@/store";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import ModalView from "@/components/ModalView";
import Multiselect from '@vueform/multiselect'
import {toast} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Swal from "@/sweetalert2";

export default {
  name: "CarriersView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push('/login');
    }
    if (!store.state.user.roles.includes('ROLE_ADMIN')) {
      this.$router.push('/');
    }
  },
  mounted() {
    if (store.state.user.roles.length > 0) {
      this.fetchCarriers();
    }
  },
  data() {
    return {
      startLoading: false,
      loading: false,
      searchValue: '',
      tableHeaders: [
        {text: "Статус", value: "status", sortable: true, width: 80},
        {text: "Наименование перевозчика", value: "name", sortable: true},
        {text: "ИНН", value: "inn", sortable: true},
        {text: "Контактное лицо", value: "contact_name", sortable: true},
        {text: "E-mail", value: "contact_email", sortable: true},
      ],
      tableItems: [],
      multiselectItems: [],
      itemsSelected: [],
      selectedCarrier: -1,
      editableCarrier: -1,
      creatableCarrier: {
        status: 'a',
        access_users: [],
        inn: '',
        kpp: '',
        orgn: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
      },
      createValidationErrors: {},
      editValidationErrors: {},
      createDialogVisible: false,
      editDialogVisible: false,
    };
  },
  components: {
    NavigationView,
    LoadingSpinner,
    Multiselect,
    ModalView
  },
  methods: {
    async fetchCarriers() {
      try {
        this.startLoading = true;
        const responses = await Promise.all([
          http.get('/api/carrier/get'),
          http.get('/api/user/get/short-noadmin')
        ]);
        if (responses[0].data !== null && responses[0].status === 200) {
          this.tableItems = responses[0].data;
        }
        if (responses[1].data !== null && responses[1].status === 200) {
          this.multiselectItems = responses[1].data.users;
        }
        // const response = await http.get('/api/carrier/get');
        // if (response.data !== null && response.status === 200) {
        //   this.tableItems = response.data;
        // }
        // const response2 = await http.get('/api/user/get/short');
        // if (response2.data !== null && response2.status === 200) {
        //   this.multiselectItems = response2.data.users;
        // }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
    clearFilters() {
      this.searchValue = '';
      this.itemsSelected = [];
      this.selectedCarrier = -1;
      this.editableCarrier = -1;
    },
    selectCarrier(item) {
      this.editValidationErrors = {};
      if (this.selectedCarrier.id === item.id) {
        this.selectedCarrier = -1;
        this.editableCarrier = -1;
        this.editDialogVisible = false;
      } else {
        this.selectedCarrier = item;
        this.editableCarrier = JSON.parse(JSON.stringify(item));
        this.editDialogVisible = true;
      }
    },
    async updateCarrier() {
      this.editValidationErrors = {};
      if (!this.editableCarrier.name) {
        this.editValidationErrors.nameError = 'Введите наименование';
      }
      if (this.editableCarrier.contact_phone && this.editableCarrier.contact_phone.length !== 18) {
        this.editValidationErrors.contactPhoneError = 'Некорректный телефон контактного лица';
      }
      // if (!this.editableCarrier.inn) {
      //   this.editValidationErrors.innError = 'Введите ИНН организации';
      // }
      // if (!this.editableCarrier.kpp) {
      //   this.editValidationErrors.kppError = 'Введите КПП организации';
      // }
      // if (!this.editableCarrier.orgn) {
      //   this.editValidationErrors.orgnError = 'Введите ОГРН организации';
      // }
      // if (!this.editableCarrier.contact_name) {
      //   this.editValidationErrors.contactNameError = 'Введите ФИО контактного лица';
      // }
      // if (!this.editableCarrier.contact_email) {
      //   this.editValidationErrors.contactEmailError = 'Введите e-mail контактного лица';
      // }
      // if (!this.editableCarrier.contact_phone) {
      //   this.editValidationErrors.contactPhoneError = 'Введите телефон контактного лица';
      // }
      if (Object.keys(this.editValidationErrors).length === 0) {
        var finalPhone = ''
        if (this.editableCarrier.contact_phone) {
          finalPhone = this.editableCarrier.contact_phone.replace('+', '').replace('(', '').replace(')', '').replaceAll('-', '').replaceAll(' ', '');
        }
        try {
          this.loading = true;
          var accessUsers = this.editableCarrier.access_users && [...this.editableCarrier.access_users].length > 0 ? [...this.editableCarrier.access_users] : [];
          var data = {
            status: this.editableCarrier.status ?? '',
            name: this.editableCarrier.name,
            inn: this.editableCarrier.inn ?? '',
            kpp: this.editableCarrier.kpp ?? '',
            orgn: this.editableCarrier.orgn ?? '',
            contact_name: this.editableCarrier.contact_name ?? '',
            contact_email: this.editableCarrier.contact_email ?? '',
            contact_phone: finalPhone ?? '',
            access_users: accessUsers,
          };
          const response = await http.post(`/api/carrier/update/${this.editableCarrier.id}`, data);
          if (response.data !== null && response.status === 200) {
            var foundCarrier = this.tableItems.find(item => item.id === this.editableCarrier.id);
            foundCarrier.name = this.editableCarrier.name;
            foundCarrier.inn = this.editableCarrier.inn ?? '';
            foundCarrier.kpp = this.editableCarrier.kpp ?? '';
            foundCarrier.orgn = this.editableCarrier.orgn ?? '';
            foundCarrier.contact_name = this.editableCarrier.contact_name ?? '';
            foundCarrier.contact_email = this.editableCarrier.contact_email ?? '';
            foundCarrier.contact_phone = finalPhone ?? '';
            foundCarrier.status = this.editableCarrier.status ?? '';
            foundCarrier.access_users = this.editableCarrier.access_users;

            this.selectedCarrier = -1;
            this.editableCarrier = -1;
            this.editDialogVisible = false;
            this.itemsSelected = [];
            toast.success('Изменения сохранены успешно!', {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async createCarrier() {
      this.createValidationErrors = {};
      if (!this.creatableCarrier.name) {
        this.createValidationErrors.nameError = 'Введите наименование';
      }
      if (this.creatableCarrier.contact_phone && this.creatableCarrier.contact_phone.length !== 18) {
        this.createValidationErrors.contactPhoneError = 'Некорректный телефон контактного лица';
      }
      // if (!this.creatableCarrier.inn) {
      //   this.createValidationErrors.innError = 'Введите ИНН организации';
      // }
      // if (!this.creatableCarrier.kpp) {
      //   this.createValidationErrors.kppError = 'Введите КПП организации';
      // }
      // if (!this.creatableCarrier.orgn) {
      //   this.createValidationErrors.orgnError = 'Введите ОГРН организации';
      // }
      // if (!this.creatableCarrier.contact_name) {
      //   this.createValidationErrors.contactNameError = 'Введите ФИО контактного лица';
      // }
      // if (!this.creatableCarrier.contact_email) {
      //   this.createValidationErrors.contactEmailError = 'Введите e-mail контактного лица';
      // }
      // if (!this.creatableCarrier.contact_phone) {
      //   this.createValidationErrors.contactPhoneError = 'Введите телефон контактного лица';
      // }

      if (Object.keys(this.createValidationErrors).length === 0) {
        var finalPhone = ''
        if (this.creatableCarrier.contact_phone) {
          finalPhone = this.creatableCarrier.contact_phone.replace('+', '').replace('(', '').replace(')', '').replaceAll('-', '').replaceAll(' ', '');
        }
        try {
          this.loading = true;
          var accessUsers = this.creatableCarrier.access_users && [...this.creatableCarrier.access_users].length > 0 ? [...this.creatableCarrier.access_users] : [];
          var data = {
            status: this.creatableCarrier.status,
            name: this.creatableCarrier.name,
            inn: this.creatableCarrier.inn ?? '',
            kpp: this.creatableCarrier.kpp ?? '',
            orgn: this.creatableCarrier.orgn ?? '',
            contact_name: this.creatableCarrier.contact_name ?? '',
            contact_email: this.creatableCarrier.contact_email ?? '',
            contact_phone: finalPhone ?? '',
            access_users: accessUsers,
          };
          const response = await http.post('/api/carrier/create', data);
          if (response.data !== null && response.status === 200) {
            this.tableItems.push({
              "id": response.data.id,
              "name": this.creatableCarrier.name,
              "inn": this.creatableCarrier.inn ?? '',
              "kpp": this.creatableCarrier.kpp ?? '',
              "orgn": this.creatableCarrier.orgn ?? '',
              "contact_name": this.creatableCarrier.contact_name ?? '',
              "contact_email": this.creatableCarrier.contact_email ?? '',
              "contact_phone": finalPhone ?? '',
              "status": this.creatableCarrier.status,
              "access_users": accessUsers,
            });
            this.createDialogVisible = false;
            this.creatableCarrier = {
              status: 'a',
              access_users: [],
              inn: '',
              kpp: '',
              orgn: '',
              contact_name: '',
              contact_email: '',
              contact_phone: '',
            };
            toast.success('Перевозчик добавлен успешно!', {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    showCreateDialog() {
      this.createDialogVisible = true;
      this.createValidationErrors = {};
    },
    async deleteMultiple() {
      var result = await Swal.fire({
        title: "Вы уверены, что хотите удалить выбранных перевозчиков?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FF7C7C",
        cancelButtonColor: "#005291",
        cancelButtonText: "Отмена",
        confirmButtonText: "Удалить"
      })
      if (result.isConfirmed) {
        try {
          this.loading = true;
          var itemsForDelete = this.itemsSelected.map(item => item.id);
          var data = {
            delete_elements: itemsForDelete,
          };
          const response = await http.post('/api/carrier/delete-multiple', data);
          if (response.data !== null && response.status === 200) {
            this.tableItems = this.tableItems.filter(item => !itemsForDelete.includes(item.id));
            this.itemsSelected = [];
            toast.success('Выбранные перевозчики удалены успешно!', {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-container {
  /*background-image: url("../assets/images/backfon.jpg");*/
  /*background-size: cover;*/
  /*background-position: center;*/
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  /*padding: 30px;*/
  overflow: hidden;
}

.tableview-block {
  background: #FFFFFF;
  /*border-radius: 10px;*/
  height: 100%;
  position: relative;
  box-shadow: 0 5px 10px #aaacbd;
}

.tableview-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}

.tableview-top-left {
  display: flex;
  align-items: center;
}

.tableview-top-count {
  font-size: 18px;
  font-family: OpenSansSemiBold, sans-serif;
  color: #005291;
  margin-right: 20px;
}

.tableview-top-search.mobile {
  display: none;
}

.tableview-top-search label {
  position: relative;
  display: flex;
}

.tableview-top-search label input {
  background-color: #ffffff;
  box-shadow: 0px 0px 10px #dde5ed;
  border: 0;
  outline: none;
  border-radius: 10px;
  width: 350px;
  height: 38px;
  padding: 10px 42px 10px 48px;
  font-size: 14px;
  font-family: OpenSansRegular, sans-serif;
  color: #4D5460;
}

.tableview-top-search label input::placeholder {
  color: #4D5460;
}

.tableview-top-search-icon {
  position: absolute;
  top: 11px;
  left: 13px;
  pointer-events: none;
}

.tableview-top-search-close {
  position: absolute;
  background: transparent;
  border: 0;
  outline: none;
  top: 8px;
  right: 9px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tableview-top-search-close svg {
  fill: #4D5460;
}

.clear-filters {
  border-radius: 10px;
  color: #FF7C7C;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  border: 1px solid #FF7C7C;
  cursor: pointer;
  transition: all .4s;
}

.clear-filters.mobile, .button-add-transparent.mobile {
  display: none;
}

.button-add-transparent {
  border-radius: 10px;
  color: #4D5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  outline: none;
  padding: 0 12px;
  margin-right: 10px;
  border: 1px solid #DDE5ED;
  cursor: pointer;
  transition: all .4s;
}

.clear-filters:active, .download-btn:active, .delete-selected-btn:active, .button-add-transparent:active {
  transform: scale(0.95);
}

.download-btn {
  border-radius: 10px;
  color: #4D5460;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #DDE5ED;
  cursor: pointer;
  transition: all .4s;
  margin-right: 10px;
}

.download-btn .mobile {
  display: none;
}

.download-btn svg {
  margin-right: 8px;
}

.delete-selected-btn {
  border-radius: 10px;
  color: #FF7C7C;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: transparent;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0 12px;
  border: 1px solid #FF7C7C;
  cursor: pointer;
  transition: all .4s;
}

.delete-selected-btn svg {
  margin-right: 8px;
}

.tableview-main {
  display: flex;
  height: calc(100% - 68px);
}

.tableview-main-left {
  width: 100%;
  height: calc(100% - 122px);
}

.tableview-main-left.not-selected {
  height: calc(100% - 64px);
}

.tableview-main-selected {
  display: flex;
  align-items: center;
  margin-top: 43px;
  justify-content: space-between;
  padding: 20px 20px 20px 30px;
}

.tableview-main-selected-left {
  font-size: 14px;
  color: #4D5460;
}

.tableview-main-selected-actions {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableview-main-selected-actions-text {
  font-size: 14px;
  color: #4D5460;
  margin-right: 12px;
}

.status-point-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 4;
}

.status-point {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #418FDE;
}

.status-point.inactive {
  background: #C1C6C8;
}

.selected-field.selected {
  background: #DDE5ED;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
}

.tableview-main-right {
  background: #DDE5ED;
  padding: 17px 20px 20px 20px;
  max-width: 420px;
  /*border-radius: 0 0 10px 0;*/
  overflow: auto;
}

.tableview-main-right-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.tableview-main-right-name {
  font-family: OpenSansBold, sans-serif;
  font-size: 20px;
  color: #005291;
  margin-right: 15px;
}

.tableview-main-right-status {
  width: 18px;
  height: 18px;
  margin-left: auto;
  flex-shrink: 0;
  border-radius: 50%;
  background: #418FDE;
}

.tableview-main-right-status.inactive {
  background: #C1C6C8;
}

.button-update {
  border-radius: 10px;
  color: #FFFFFF;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  background: #005291;
  width: 100%;
  height: 38px;
  outline: none;
  border: 0;
  padding: 0 12px;
  cursor: pointer;
  transition: all .4s;
}

.button-update:active {
  transform: scale(0.95);
}

.button-add {
  width: 100%;
  height: 38px;
  background: #005291;
  color: #ffffff;
  border: 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  font-family: OpenSansRegular, sans-serif;
  font-size: 13px;
  transition: all .4s;
}

.button-add:active {
  transform: scale(0.95);
}

.edit-modal {
  display: none;
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .tableview-main-right {
    display: none;
  }

  .edit-modal {
    display: initial;
  }

  .tableview-top-search label input {
    width: 300px;
  }
}

/* < 960 */
@media screen and (max-width: 959px) {

  /*верхняя строка*/
  .tableview-top-search.pc {
    display: none;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 20px 15px 20px;
  }

  .tableview-top-search label input {
    width: 100%;
  }

  /*таблица*/
  .tableview-main {
    display: flex;
    height: calc(100% - 121px);
  }
}

/* < 768 */
@media screen and (max-width: 767px) {
  .tableview-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
  }

  .tableview-top-search.mobile {
    display: block;
    padding: 0 15px 15px 15px;
  }

  .tableview-main-selected-actions-text {
    display: none;
  }

  .tableview-main-selected {
    padding: 20px 15px 20px 15px;
  }
}

/* < 620 */
@media screen and (max-width: 619px) {
  .tableview-top-count {
    font-size: 16px;
    margin-right: 0;
  }

  .button-add-transparent.mobile, .clear-filters.mobile {
    display: initial;
    padding: 0;
    width: 38px;
    height: 38px;
  }

  .button-add-transparent.mobile {
    border: 1px solid rgb(40, 189, 74);
  }

  .button-add-transparent.mobile svg {
    width: 20px;
    height: 20px;
  }

  .button-add-transparent.mobile svg {
    fill: rgb(40, 189, 74);
  }

  .clear-filters.mobile svg {
    width: 24px;
    height: 24px;
  }

  .clear-filters.mobile svg, .clear-filters.mobile svg path {
    fill: #FF7C7C;
  }

  .clear-filters.pc, .button-add-transparent.pc {
    display: none;
  }

  .delete-selected-btn {
    height: 38px;
    width: 38px;
    padding: 1px;
  }

  .delete-selected-btn span {
    display: none;
  }

  .delete-selected-btn svg {
    margin-right: 0;
  }

  .download-btn .pc {
    display: none;
  }

  .download-btn .mobile {
    display: initial;
  }

  .tableview-main-selected {
    padding: 15px;
  }

  .tableview-main-left {
    height: calc(100% - 110px);
  }

  .tableview-main-left.not-selected {
    height: calc(100% - 44px);
  }
}
</style>